( function ( $ ){ // Self Executing function with $ alias for jQuery

	/**
	 *  Initialization  similar to include once but since all js is loaded by the browser automatically the all
	 *   we have to do is call our functions to initialize them, his is only run in the main configuration file
	 */
	$( document ).ready( function (){

		if ($( '#group-report' ).length > 0) {
			window.ulgmGroupManagement.reportingTemplating.constructor();
		}

		if ($( '#uo-quiz-report-table' ).length > 0) {
			window.ulgmGroupManagement.quizReport.constructor();
		}

		if ($( '#uo-group-report-course' ) > 0) {
			$( '#uo-group-report-course' ).select2();
		}

	} );

	window.ulgmGroupManagement.reportingTemplating = {

		rowTemplate: '',
		itemTemplate: '',
		liTemplate: '',
		items: [],
		itemsEl: [],
		jpL: false,

		// initialize the code
		constructor: function (){
			if ($( '#group-report' ).length > 0) {
				// Get Template
				this.itemTemplate = $( 'script[data-template="item"]' ).text().split( /\$\{(.+?)\}/g );
			}
		},

		setItems: function ( items ){

			var _this = this;

			// Reset Items
			this.itemsEl = [];

			// Create items from JSON
			items.map( function ( item ){
				_this.itemsEl.push( $( '<div class="uo-tbl-item body-row">' + _this.itemTemplate.map( _this.render( item ) ).join( '' ) + '</div>' ) );
				return '<div class="uo-tbl-item body-row">' + _this.itemTemplate.map( _this.render( item ) ).join( '' ) + '</div>';
			} );

		},

		render: function ( props ){
			return function ( tok, i ){
				return ( i % 2 ) ? props[tok] : tok;
			};
		}
	};

	window.ulgmGroupManagement.populateCoursesDropDown = function ( data ){

		var courseDropDown = $( '#uo-group-report-course' );
		courseDropDown.empty();

		$( '#course-group-id' ).val( data.group_id );

		if (data.group_courses.length > 1) {
			courseDropDown.append(
				$( '<option>', {
					value: '0',
					text: ulgmRestApiSetup.localized.selectCourse
				} )
			);
		}
		/**/

		$.each( data.group_courses, function ( i, course ){

			courseDropDown.append(
				$( '<option>', {
					value: course.ID,
					text: course.post_title
				} )
			);

		} );

		courseDropDown.show().trigger( 'change' );

	};


	window.ulgmGroupManagement.quizReport = {

		uoTable: null,

		uoTableHidden: null,

		quizId: 0,

		groupId: 0,

		courseId: 0,

		constructor: function (){
			this.$elements = {
				filters: {
					group: document.getElementById( 'uo-group-report-group' ),
					course: document.getElementById( 'uo-group-report-courses' ),
					quiz: document.getElementById( 'uo-group-report-quizzes' ),
				}
			}

			this.createTable();
			this.createTableHidden();
			this.addEvents();

			// Trigger change on the first dropdown on load
			this.$elements.filters.group.dispatchEvent( new Event( 'change' ) );
		},

		initSelect2: function() {
			try {
				[ this.$elements.filters.group, this.$elements.filters.course, this.$elements.filters.quiz ].forEach( ( $element ) => {
					$element.select2();
				} );
			} catch ( e ) {
				console.error( e );
			}
		},

		createTable: function ( data ){

			ulgmQuizReportShortcode.table = ulgmQuizReportShortcode.table || {};

			let columnsVisibility = jQuery( '#uo-quiz-report-table' ).data( 'table_columns' );
			columnsVisibility     = columnsVisibility.split( ',' );

			var columnsConfig = ulgmQuizReportShortcode.table.columnsConfig;
			var columns = Object.entries(columnsConfig).map(([key, value], i) => {
				var column = {
					title: value,
					targets: i,
					data: key,
					visible: columnsVisibility.includes(key),
					orderable: true,
					searchable: true
				};
				if (key === 'quiz_modal') {
					column = {...column, orderable: false, searchable: false, defaultContent: ''};
				}
				return column;
			});

			// Check what column has to be used to sort the table
			let tableOrder = [];
			// Find the index of the column we have to use to sort
			let tableOrderByIndex = columns.findIndex( columnData => columnData.title == ulgmQuizReportShortcode.table.orderBy );

			// If the column doesn't exist, then try to get the default one
			if ( tableOrderByIndex === -1 ) {
				tableOrderByIndex = columns.findIndex( columnData => columnData.data == 'quiz_date' );
			}
			// If the one defined by the user, or the default one exists, add it
			if ( tableOrderByIndex !== -1 ) {
				tableOrder = [
					[
						tableOrderByIndex, // The ID of the column used to sort, defaults to `quiz_date`
						ulgmQuizReportShortcode.table.order, // Designates the ascending or descending order of the ‘orderby‘ parameter, defaults to `desc`
					]
				];
			}

			var tableVars = {
				aLengthMenu: [
					[15, 30, 60, -1],
					[15, 30, 60, groupQuizReportSetup.localized.all]
				],
				order: tableOrder,
				iDisplayLength: 30,
				columns: columns,
				columnDefs: []
			};

			let initComplete = ( settings, d ) => {

				let table = settings.oInstance.api();
				let _this = this;

				var colFilter_container = $( `<div id="${settings.sInstance}-filter-columns" class="dataTables-filter-columns"><input class="dataTables-filter-columns-field" id="${settings.sInstance}-filter-columns-field" type="checkbox"><div class="dataTables-filter-columns__toggle"><label for="${settings.sInstance}-filter-columns-field" data-label-enable="${groupQuizReportSetup.localized.customizeColumns}" data-label-disable="${groupQuizReportSetup.localized.hideCustomizeColumns}"></label></div><div class="dataTables-filter-columns__fields"></div></div>` );

				if (settings.oSavedState !== null) {
					jQuery.each( settings.oSavedState.columns, function ( key, value ){
						var col       = settings.aoColumns[key];
						var configKey = col.data;
						if ( ! columnsConfig.hasOwnProperty( configKey ) ) {
							return;
						}
						var title = col.sTitle;
						colFilter_container.find( '.dataTables-filter-columns__fields' ).append( _this.addColumnCourseCheckbox( title, key, value.visible, table ) );

					} );
				} else {
					jQuery.each( settings.aoColumns, function ( key, value ){
						var col       = settings.aoColumns[key];
						var configKey = col.data;
						if ( ! columnsConfig.hasOwnProperty( configKey ) ) {
							return;
						}
						var title = col.sTitle;
						colFilter_container.find( '.dataTables-filter-columns__fields' ).append( _this.addColumnCourseCheckbox( title, key, value.bVisible, table ) );

					} );
				}

				$( colFilter_container ).insertAfter( '#uo-quiz-report-table_filter' );


			};

			tableVars.initComplete = initComplete;
			tableVars.stateSave    = true;

			if (null !== this.uoTable) {

				this.uoTable.destroy();

				tableVars.data = data;
			}

			tableVars.language = groupQuizReportSetup.localized.tableLanguage;
			this.uoTable = jQuery( '#uo-quiz-report-table' );

			if (jQuery( '#uo-quiz-report-table' ).length > 0) {
				this.uoTable = jQuery( '#uo-quiz-report-table' ).DataTable( tableVars );
			}


		},

		createTableHidden: function ( data ){
			var columnsConfig = ulgmQuizReportShortcode.table.columnsConfig;
			var columns = Object.entries(columnsConfig).map(([key, value]) => {
				return {
					title: value,
					data: key
				};
			});

			var buttonCommon = {
				exportOptions: {
					columns: ( id, data, node ) => {
                        return this.uoTable.column( id ).visible();
                    },
                    
					format: {
						body: function (data, row, column, node) {
							// Strips hidden timestamp <span>
							return data.replace(/\<span\s(?:class\=\"ulg\-hidden\-data\")(.*)\<\/span\>/g, '');
						}
					}
				}
			};

			let exportButtons = [];
			if ( ulgmQuizReportShortcode.table.showCSVExportButton ) {
				exportButtons.push( $.extend(true, {}, buttonCommon, {
					extend: 'csv',
					text: groupQuizReportSetup.i18n.exportCSV,
				} ) );
			}
			if ( ulgmQuizReportShortcode.table.showExcelExportButton ) {
				exportButtons.push( $.extend(true, {}, buttonCommon, {
					extend: 'excelHtml5',
					text: groupQuizReportSetup.i18n.exportExcel,
				}) );
			}

			var tableVars = {
				iDisplayLength: -1,
				columns: columns,
				dom: 'Bfrtip',
				buttons: exportButtons
			};

			if ($.fn.DataTable.isDataTable( '#uo-quiz-report-table-hidden' )) {

				$( '#uo-quiz-report-table-hidden' ).DataTable().destroy();

				tableVars.data    = data;
				tableVars.columns = Object.entries(columnsConfig).map(([key, value]) => {
					return {
						title: value,
						data: key
					};
				});

			}

			tableVars.language = groupQuizReportSetup.localized.tableLanguage;
			this.uoTableHidden = jQuery( '#uo-quiz-report-table-hidden' );

			if (this.uoTableHidden.length > 0) {
				this.uoTableHidden = jQuery( '#uo-quiz-report-table-hidden' ).DataTable( tableVars );
			}

			$( '.buttons-csv' ).show();

		},

		addColumnCourseCheckbox: function ( label, column_key, is_visible, table ){

			var checkbox = jQuery( '<input />', {
				type: 'checkbox',
				id: 'dt_' + column_key,
				value: column_key,
				checked: is_visible
			} );

			checkbox.on( 'change', function ( e ){
				// Get the column API object
				var current_check = jQuery( this ).attr( 'value' );
				var is_checked    = jQuery( this ).is( ':checked' );

				table.columns().every( function ( index ){

					var column = table.column( index );

					// ... do something with data(), or this.nodes(), etc

					if (index == current_check) {
						if (is_checked) {
							// Toggle the visibility
							column.visible( true );
						} else {
							column.visible( false );
						}
					}


				} );

			} );

			var $label = jQuery( '<label/>' ).append( checkbox ).append( label );
			return $label;
		},

		addEvents: function (){
			// Listen changes to the "Group" dropdown
			this.$elements.filters.group.addEventListener( 'change', ( event ) => {
				// Set loading animation in the course dropdown
				this.setLoading( {
					$dropdown: this.$elements.filters.course,
					isLoading: true
				} );

				// Do REST call to get courses
				$.ajax( {
					method: 'POST',
					data: { group_id: this.$elements.filters.group.value },
					url: groupQuizReportSetup.root + 'quiz-report-get-courses/',
					beforeSend: xhr => xhr.setRequestHeader( 'X-WP-Nonce', groupQuizReportSetup.nonce ),
					success: ( response ) => {
						// Check if the call is valid
						if ( ! response.success ) {
							return;
						}

						// Check if the returned data is valid
						if ( ! Array.isArray( response.options ) ) {
							return;
						}

						// Set loading
						this.setLoading( {
							$dropdown: this.$elements.filters.course,
							isLoading: false
						} );

						// Set new options
						this.setOptions(
							this.$elements.filters.course,
							response.options,
							{
								placeholder: groupQuizReportSetup.i18n.coursePlaceholder
							}
						);

						// Check if it has options
						if ( response.options.length === 0 ) {
							// Enable the dropdown
							this.$elements.filters.course
								.setAttribute( 'disabled', 'disabled' );
						}
					},
					fail: () => {
						// Set loading
						this.setLoading( {
							$dropdown: this.$elements.filters.course,
							isLoading: false
						} );
					}
				} );
			} );

			// Listen changes to the "Course" dropdown
			this.$elements.filters.course.addEventListener( 'change', ( event ) => {
				// Check if the course ID is valid
				if ( parseInt( this.$elements.filters.course.value ) === 0 ) {
					// Clear the "Quiz" dropdown
					this.setOptions(
						this.$elements.filters.quiz,
						[]
					);

					// Clear data on the table
					try {
						this.uoTable.clear().draw();
					} catch ( e ) {
						console.error( e );
					}

					return;
				}

				// Set loading animation in the quiz dropdown
				this.setLoading( {
					$dropdown: this.$elements.filters.quiz,
					isLoading: true
				} );

				// Do REST call to get quizzes
				$.ajax( {
					method: 'POST',
					data: { 
						group_id: this.$elements.filters.group.value,
						course_id: this.$elements.filters.course.value
					},
					url: groupQuizReportSetup.root + 'quiz-report-get-quizzes/',
					beforeSend: xhr => xhr.setRequestHeader( 'X-WP-Nonce', groupQuizReportSetup.nonce ),
					success: ( response ) => {
						// Check if the call is valid
						if ( ! response.success ) {
							return;
						}

						// Check if the returned data is valid
						if ( ! Array.isArray( response.options ) ) {
							return;
						}

						// Set loading
						this.setLoading( {
							$dropdown: this.$elements.filters.quiz,
							isLoading: false
						} );

						// Set new options
						this.setOptions(
							this.$elements.filters.quiz,
							response.options,
							{
								placeholder: groupQuizReportSetup.i18n.quizPlaceholder
							}
						);

						// Check if it has options
						if ( response.options.length === 0 ) {
							// Enable the dropdown
							this.$elements.filters.quiz
								.setAttribute( 'disabled', 'disabled' );
						}
					},
					fail: () => {
						// Set loading
						this.setLoading( {
							$dropdown: this.$elements.filters.quiz,
							isLoading: false
						} );
					}
				} );
			} );

			// Listen changes to the "Quiz" dropdown
			this.$elements.filters.quiz.addEventListener( 'change', ( event ) => {
				// Request data
				window.ulgmGroupManagement.quizReport.getQuizData(
					// Quiz ID
					this.$elements.filters.quiz.value,
					// Group ID
					this.$elements.filters.group.value,
					// Score type
					groupQuizReportSetupScoreType
				);
			} );
		},

		setOptions: ( $dropdown, options = [], dropdownSettings = {} ) => {
			// Empty the dropdown
			$dropdown.innerHTML = '';

			// Check if it doesn't have any options
			if ( options.length === 0 ) {
				$dropdown.innerHTML = `
					<option>${ groupQuizReportSetup.i18n.noResults }</option>
				`;

				$dropdown.classList.add( 'uo-groups-select-filter-select--empty' );
			} else {
				// Check if there is more than one option and if we should add a placeholder
				if ( options.length > 1 && typeof dropdownSettings.placeholder !== 'undefined' && dropdownSettings.placeholder !== '' ) {
					$dropdown.insertAdjacentHTML( 'beforeEnd', `<option value="0">${ dropdownSettings.placeholder }</option>` );
				}

				// Add options
				options.forEach( option => $dropdown.insertAdjacentHTML( 'beforeEnd', `<option value="${ option.value }">${ option.text }</option>` ) );

				$dropdown.classList.remove( 'uo-groups-select-filter-select--empty' );
			}

			// Trigger change event, there are new options
			$dropdown.dispatchEvent( new Event( 'change' ) );
		},

		setLoading: function( { isLoading, $dropdown } ) {
			// Get wrapper
			const $wrapper = $dropdown.closest( '.uo-groups-select-filter' );

			if ( ! $wrapper ) {
				return;
			}

			if ( isLoading ) {
				// Add loading class
				$wrapper.classList.add( 'uo-groups-select-filter--loading' );

				// Disable the dropdown
				$dropdown.setAttribute( 'disabled', 'disabled' );
			} else {
				// Add the loading class
				$wrapper.classList.remove( 'uo-groups-select-filter--loading' );

				// Enable the dropdown
				$dropdown.removeAttribute( 'disabled' );
			}
		},

		format: function ( d ){

			var rows = '';
			$.each( d.answer, function ( key, value ){
				rows +=
					'<tr>' +
					'<td>' + d.question[key] + '</td>' +
					'<td>' + value + '</td>' +
					'</tr>';
			} );
			// `d` is the original data object for the row
			return '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' + rows + '</table>';
		},

		getQuizData: function ( quizId, groupId, scoreType ){
			// Clear data on the table
			try {
				this.uoTable.clear().draw();
			} catch ( e ) {
				console.error( e );
			}

			if (!window.ulgmGroupManagement.reporting.isNormalInteger( quizId )) {
				$( '#uo-group-report-course' ).addClass( 'missing' );
				return false;
			}

			if (!window.ulgmGroupManagement.reporting.isNormalInteger( String( groupId ) )) {
				return false;
			}

			$( '#uo-group-report-course' ).removeClass( 'missing' );

			var i = 0;

			var loading = setInterval( function (){
				i = ++i % 4;
				$( "#uo-quiz-report-table tbody" ).html( "<div id='group-loader'>" + groupQuizReportSetup.localized.loadingRecords + new Array( i + 1 ).join( "." ) + "</div>" );
			}, 500 );


			var dataVars = {
				groupId: groupId,
				quizId: quizId,
				scoreType: scoreType
			};

			$.ajax( {

				method: "POST",
				data: dataVars,
				url: groupQuizReportSetup.root + 'get_quiz_data/',
				beforeSend: function ( xhr ){
					xhr.setRequestHeader( 'X-WP-Nonce', groupQuizReportSetup.nonce );
				},
				success: function ( response ){
					clearInterval( loading );
					$( '#group-loader' ).remove();

					window.ulgmGroupManagement.quizReport.createTable( response );
					window.ulgmGroupManagement.quizReport.createTableHidden( response );


				},
				fail: function ( response ){
					alert( 'Rest Call Failed' );
				}

			} );

		}

	};

	window.ulgmGroupManagement.reporting = {

		groupLeaderId: 0,

		groupId: 0,

		getGroupCourses: function ( groupId ){

			var dataVars = {groupId: groupId};

			if (this.getQueryVariable( 'user_id' )) {
				window.ulgmGroupManagement.reporting.groupLeaderId = this.getQueryVariable( 'user_id' );
				dataVars.userId                                    = window.ulgmGroupManagement.reporting.groupLeaderId;
			}

			$( '#uo-group-report-course' ).hide();

			$.ajax( {

				method: "POST",
				data: dataVars,
				url: groupQuizReportSetup.root + 'get_group_courses/',
				beforeSend: function ( xhr ){
					xhr.setRequestHeader( 'X-WP-Nonce', groupQuizReportSetup.nonce );
				},
				success: function ( response ){
					window.ulgmGroupManagement.reporting.createCourseDropDown( response.courses );

					if ($( '#uo-quiz-report-table' ).length) {
						window.ulgmGroupManagement.reporting.createUserDropDown( response.users );
					}


				},
				fail: function ( response ){
					alert( 'Rest Call Failed' );
				}

			} );

		},

		createCourseDropDown: function ( posts ){
			var dropDown = $( '#uo-group-report-course' ),
				options  = '<option value="0">' + ulgmRestApiSetup.localized.selectCourse + '</option>';

			if (0 === posts.post_count) {
				dropDown.html( '<option value="0">' + ulgmRestApiSetup.localized.noCourse + '</option>' );
				return true;
			}

			$.each( posts.posts, function ( key, post ){
				options += '<option value="' + post.ID + '">' + post.post_title + '</option>';
			} );

			dropDown.html( options );
			dropDown.show();

		},

		createUserDropDown: function ( users ){

			var dropDown = $( '#uo-group-report-user' ),
				options  = '<option value="0">' + groupQuizReportSetup.localized.selectUser + '</option>';

			if (0 === users.length) {
				dropDown.html( '<option value="0">' + groupQuizReportSetup.localized.noUsers + '/option>' );
				return true;
			}

			$.each( users, function ( key, user ){
				options += '<option value="' + user.ID + '">' + user.data.display_name + '</option>';
			} );

			dropDown.html( options );
			dropDown.show();

		},

		isNormalInteger: function ( str ){
			var n = Math.trunc( str );
			n = isNaN( n ) ? 0 : n;

			return String( n ) == str && n > 0;
		},

		getQueryVariable: function ( variable ){
			var query = window.location.search.substring( 1 );
			var vars  = query.split( "&" );
			for (var i = 0; i < vars.length; i++) {
				var pair = vars[i].split( "=" );
				if (pair[0] == variable) {
					return pair[1];
				}
			}
			return ( false );
		}

	}


} )( jQuery );
